module.exports = __webpack_public_path__ + "static/img/text-logo.df8423db.png";